export const API_HOST = (
  process.env.VUE_APP_API_URL || "https://juki-backend.ddev.site:4321"
).replace(/\/$/, "");

export function mediaUrl(media, size = "card") {
  if (!media || typeof media !== "object") return "";
  const path =
    size !== "original" && media.sizes && media.sizes[size] && media.sizes[size].url
      ? media.sizes[size].url
      : media.url;
  if (!path) return "";
  return /^https?:\/\//.test(path) ? path : `${API_HOST}${path}`;
}
